import { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';

/** Code 128 barcode rendered as SVG. Non-ASCII characters are dropped, as Code 128 can't encode them. */
export default function Barcode({ value, height = 38, label }) {
  const svg = useRef(null);
  const [failed, setFailed] = useState(false);
  const text = String(value || '').normalize('NFKD').replace(/[^\x20-\x7E]/g, '');

  useEffect(() => {
    if (!svg.current || !text) return;
    try {
      JsBarcode(svg.current, text, {
        format: 'CODE128',
        height,
        width: 1.3,
        margin: 0,
        displayValue: true,
        fontSize: 11,
        textMargin: 2,
        background: 'transparent',
      });
      setFailed(false);
    } catch {
      // Rendering needs canvas text measurement; show the encoded value if it is unavailable.
      setFailed(true);
    }
  }, [text, height]);

  if (!text) return null;
  if (failed) return <code className="barcode-fallback">{text}</code>;
  return <svg ref={svg} className="barcode" role="img" aria-label={label || `Barcode ${text}`} />;
}
